export function safeBase64Encode(str: string) {
    return btoa(encodeURIComponent(str)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function safeBase64Decode(str: string) {
    const newStr = str.replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(atob(newStr));
}

export const encodeString = (str: string) => encodeURIComponent(btoa(str));
export const decodeString = (str: string) => atob(decodeURIComponent(str));
